<!-- Desktop -->
<div
    id="player"
    data-testid="desktop-player"
    class="player-container lg-devices hidden fixed inset-x-0.5 border-solid border border-player text-white rounded-2xl md:flex flex-col justify-center">
    <div class="player-surface rounded-2xl absolute inset-0 z-0"></div>

    <div id="player-wrapper" class="rounded-2xl p-2 md:items-center z-10">
        <div class="player-track-details">
            <span
                *ngIf="
                    (playerService.query.currentSong$ | async)?.song === null
                "
                class="text-white text-sm"></span>

            <div id="artist-and-song">
                <div
                    id="music-title"
                    data-testid="desktop-title"
                    class="text-sm text-white !font-bold truncate">
                    {{ (playerService.query.currentSong$ | async)?.song.title }}
                </div>
            </div>
        </div>

        <div class="player-playback-section">
            <div
                id="controls"
                class="grid player-controls justify-evenly md:justify-around items-center w-full mt-2 md:mt-0 md:w-auto">
                <div
                    id="previous"
                    data-testid="desktop-previous"
                    class="cursor-pointer hidden md:block"
                    (click)="previous()"></div>
                <div
                    id="play"
                    data-testid="desktop-play"
                    class="p-2 cursor-pointer"
                    (click)="play()"
                    *ngIf="!(playerService.query.isPlaying$ | async)"></div>
                <div
                    id="pause"
                    data-testid="desktop-pause"
                    class="p-2 cursor-pointer"
                    (click)="pause()"
                    *ngIf="playerService.query.isPlaying$ | async"></div>
                <div
                    id="next"
                    data-testid="desktop-next"
                    class="cursor-pointer hidden md:block"
                    (click)="next()"></div>
            </div>

            <div
                id="progress"
                class="grid items-center mt-2 md:mt-0 cursor-default">
                <div
                    id="time-elapsed"
                    data-testid="desktop-time-elapsed"
                    class="text-xs md:text-sm">
                    {{ currentTimeText }}
                </div>

                <div
                    class="w-full py-3 cursor-pointer overflow-hidden"
                    *ngIf="false"
                    (click)="seek($event)">
                    <div
                        class="w-full relative h-1 rounded-full overflow-hidden">
                        <div
                            class="w-full progress-bar-wrapper shadow-inner h-1 absolute top-0 left-0"></div>

                        <div
                            class="bg-gray-600 shadow-inner h-1 absolute top-0 left-0"
                            [style.width.%]="
                                playerService.query.bufferLoadingProgress$
                                    | async
                            "></div>
                        <div
                            class="progress-bar bg-green-500 h-full pointer-events-none absolute top-0 left-0"
                            [style.width.%]="progress"></div>
                    </div>
                </div>

                <div
                    data-testid="desktop-progress"
                    class="w-full h-6 cursor-pointer relative"
                    *ngIf="true"
                    (click)="seek($event)">
                    <canvas #playerCanvas class="w-full h-full"></canvas>
                </div>

                <div
                    id="total-time"
                    data-testid="desktop-total-time"
                    class="text-xs md:text-sm">
                    {{ durationText }}
                </div>
            </div>
        </div>

        <button
            *ngIf="showLyricsButton"
            type="button"
            class="lyrics-player-button"
            [class.active]="lyricsPanelOpen"
            [disabled]="playerService.query.currentSong === null"
            [attr.aria-expanded]="lyricsPanelOpen"
            aria-controls="song-lyrics-panel"
            (click)="toggleLyricsPanel()">
            <img src="assets/img/player/lyrics.svg" alt="" aria-hidden="true" />
            Lyrics
        </button>
    </div>
</div>

<!-- Mobile Minimised -->
<div
    id="minimized-mobile-player"
    data-testid="mobile-minimized-player"
    class="player-container player mobile-minimized md:hidden fixed inset-x-0.5 border border-solid border-player text-white rounded-xl flex flex-col justify-center overflow-hidden">
    <div
        class="backdrop-blur-md rounded-xl absolute inset-0 bg-black bg-opacity-65 z-0"></div>

    <div
        data-testid="mobile-maximize"
        class="drag-handle-wrapper mobile-player-toggle flex justify-center items-center w-full absolute h-4 top-0 left-0 cursor-pointer"
        role="button"
        tabindex="0"
        aria-label="Maximize player"
        (click)="maximizePlayer()">
        <div
            class="drag-handle w-6 h-1 bg-gray-500 hover:bg-gray-100 rounded-full absolute top-1"></div>
    </div>

    <div class="relative rounded-xl flex flex-row p-2 z-10 overflow-hidden">
        <div
            class="song-meta-and-player-controls flex flex-row items-center w-full justify-between">
            <div
                class="song-meta flex items-center mr-4"
                (click)="maximizePlayer()">
                <div id="artist-and-song" class="flex mr-2 flex-col truncate">
                    <div
                        id="music-title"
                        data-testid="mobile-minimized-title"
                        class="w-full text-sm text-white !font-bold truncate">
                        {{
                            (playerService.query.currentSong$ | async)?.song
                                .title
                        }}
                    </div>
                </div>
            </div>
            <div id="controls" class="flex items-center size-10 mr-2">
                <img
                    data-testid="mobile-minimized-play"
                    src="assets/img/player/player-filled.svg"
                    class="cursor-pointer size-full"
                    (click)="play()"
                    *ngIf="!(playerService.query.isPlaying$ | async)" />
                <img
                    data-testid="mobile-minimized-pause"
                    src="assets/img/player/pause_filled.svg"
                    class="cursor-pointer size-full"
                    (click)="pause()"
                    *ngIf="playerService.query.isPlaying$ | async" />
            </div>
        </div>
    </div>
</div>

<!-- Mobile Maximised -->
<div
    #maxPlayer
    id="maximized-mobile-player"
    data-testid="mobile-maximized-player"
    [ngClass]="{
        'translate-y-0': mobileMaximized,
        'translate-y-full': !mobileMaximized
    }"
    class="player mobile-maximized translate-y-full md:hidden fixed bottom-0 border border-solid border-player text-white rounded-tl-xl rounded-tr-xl flex flex-col justify-center transition-transform duration-300 size-full overflow-hidden">
    <div
        data-testid="mobile-minimize"
        class="drag-handle-wrapper mobile-player-toggle flex justify-center items-center w-full absolute h-8 top-0 left-0 cursor-pointer"
        role="button"
        tabindex="0"
        aria-label="Minimize player"
        (click)="minimizePlayer()">
        <div
            class="drag-handle w-8 h-1 bg-gray-500 rounded-full absolute top-2"></div>
    </div>

    <div
        class="mobile-player-content relative rounded-tl-xl rounded-tr-xl flex flex-col items-center p-5 z-10 overflow-hidden w-full">
        <div class="song-meta flex flex-col w-full">
            <div
                id="artist-and-song"
                class="flex w-full flex-col justify-center">
                <div
                    id="music-title"
                    data-testid="mobile-title"
                    class="text-lg text-white !font-bold truncate">
                    {{ (playerService.query.currentSong$ | async)?.song.title }}
                </div>
            </div>
        </div>

        <section
            *ngIf="showLyricsButton"
            class="mobile-inline-lyrics"
            tabindex="0"
            [attr.aria-label]="
                'Lyrics for ' +
                ((playerService.query.currentSong$ | async)?.song.title ||
                    'current song')
            ">
            <pre *ngIf="currentLyrics; else mobileLyricsEmpty">{{
                currentLyrics
            }}</pre>
            <ng-template #mobileLyricsEmpty>
                <p>No lyrics for this song</p>
            </ng-template>
        </section>

        <div
            class="mobile-progress-section flex flex-col w-full items-center mx-4 mt-7 cursor-pointer">
            <div
                data-testid="mobile-progress"
                class="mobile-progress-hit-area w-full mx-2 cursor-pointer"
                (click)="seek($event)">
                <div class="mobile-progress-track shadow-inner">
                    <div
                        class="progress-bar bg-green-500 h-full pointer-events-none"
                        [style.width.%]="progress"></div>
                </div>
            </div>
            <div
                class="time flex flex-row justify-between items-center w-full mt-1">
                <div id="time-elapsed" class="mobile-time-indicator flex">
                    {{ currentTimeText }}
                </div>
                <div id="total-time" class="mobile-time-indicator flex">
                    {{ durationText }}
                </div>
            </div>
        </div>

        <div
            id="controls"
            class="player-controls flex justify-evenly items-center mt-3">
            <img
                data-testid="mobile-previous"
                src="assets/img/player/previous_filled.svg"
                class="p-2 cursor-pointer w-10 h-10"
                (click)="previous()" />

            <img
                data-testid="mobile-play"
                src="assets/img/player/player-filled.svg"
                class="p-2 cursor-pointer w-20 h-20"
                (click)="play()"
                *ngIf="!(playerService.query.isPlaying$ | async)" />
            <img
                data-testid="mobile-pause"
                src="assets/img/player/pause_filled.svg"
                class="p-2 cursor-pointer w-20 h-20"
                (click)="pause()"
                *ngIf="playerService.query.isPlaying$ | async" />

            <img
                data-testid="mobile-next"
                src="assets/img/player/next_filled.svg"
                class="p-2 cursor-pointer w-10 h-10"
                (click)="next()" />
        </div>
    </div>
</div>
